import { render, staticRenderFns } from "./StatusLight.vue?vue&type=template&id=2d7ff2ae&scoped=true&"
import script from "./StatusLight.vue?vue&type=script&lang=js&"
export * from "./StatusLight.vue?vue&type=script&lang=js&"
import style0 from "./StatusLight.vue?vue&type=style&index=0&id=2d7ff2ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ff2ae",
  null
  
)

export default component.exports